import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function convertNumberToMarketValue(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '-';

  const numericValue = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(numericValue)) return '-';

  if (numericValue >= 1_000_000_000) {
    return `€${(numericValue / 1_000_000_000).toFixed(1)}bn`;
  }

  if (numericValue >= 1_000_000) {
    return `€${(numericValue / 1_000_000).toFixed(1)}m`;
  }

  if (numericValue >= 1_000) {
    return `€${(numericValue / 1_000).toFixed(1)}k`;
  }

  return `€${numericValue}`;
}